<template>
<div class="main-view-mobile">
        <MainViewMobileHeader
            v-if="isInToca === false && doc_type == 'DOCUMENT'"
            class="mobile-header"
            :fileId="doc_id"
            ref="mobileHeader"
        ></MainViewMobileHeader>
        <div
            :style="{
                height: isInToca === true ? '100%' : 'calc(100% - 42px)',
                display: 'flex',
                minWidth: '0',
                userSelect: 'auto'
            }"
            v-if="doc_view == 'home'"
        >
            <OtherView
                v-if="doc_type == 'DOCUMENT' && edit_doc_type != 'NORMAL'"
                @submit_password="checkFileAuth"
            />
            <Edit
                v-if="doc_type == 'DOCUMENT' && edit_doc_type == 'NORMAL'"
                ref="editRef"
                @onChangeEditStatus="onChangeEditStatus"
            />
            <WpsWrap
                v-else-if="
                    doc_type == 'PPT' ||
                        doc_type == 'EXCEL' ||
                        doc_type == 'WORD'
                "
                @handleOpen="handleOpen"
            />
            <NoPreview v-if="doc_type == ''" />
        </div>
        <NoFile v-if="doc_view == 'emptyfile'" />
        <NoAuth v-if="doc_view == 'noauth'" />
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { mapActions, mapState, mapGetters } from 'vuex';

import Edit from '../components/kbedit/Edit.vue';

import WpsWrap from '../components/wps/WpsWrap.vue';
import { getKBTreeNode } from '../core/api/file';
import KbDelte from '../components/otherview/KbDelte.vue';

import NoPreview from '../components/otherview/NoPreview.vue';
import { getNodeInfo } from '../store/kbTreeNodeModule';
import { HocuspocusModule } from '../store/types';

import FileSocket, { FileSocketResp } from '../core/api/FileSocket';
import { changeLinkIcon } from '../utils/changeLinkIcon';

import { checkFileAuth, recheckFile } from '../utils/checkAuth';
import OtherView from '../components/otherview/OtherView.vue';
import { getBrowser } from '../utils/browser';
import MainViewMobileHeader from './MainViewMobileHeader.vue';
import { store } from '../store/store';

export default {
  name: 'main_view',
  components: {
    Edit,
    WpsWrap,
    KbDelte,
    NoPreview,
    OtherView,
    MainViewMobileHeader },

  data() {
    return {
      checkFileAuth: checkFileAuth,
      loading: true,
      noKbSpace: false,
      emptySpace: false,
      fileSocket: null };

  },
  created() {
    document.body.style.overscrollBehaviorX = 'none';
  },
  mounted() {
    document.getElementById('loading')?.remove();
    const params = new URL(location.href).searchParams;
    const paramFid = params.get('fid');
    //进入知识库第一步查询目录接口(备注： 移动端知识库不需要目录)
    // this.initDir(paramFid);
  },
  watch: {
    doc_info: {
      deep: true,
      handler(val) {
        //文件信息变化
        console.log('doc_infodoc_info', val);
        //重新检查权限根据权限检查决定如何显示
        recheckFile(val);
        document.title = '';
      } },

    doc_id: {
      handler(val) {
        if (val !== null) {
          this.checkFileAuth();
          // if (this.doc_type == 'DOCUMENT') {
          this.startFieSocket();
          // }
        }
      },
      immediate: true,
      deep: true },

    faviconUrl: {
      handler(val) {
        console.log('faviconUrlfaviconUrlfaviconUrl', val);
        changeLinkIcon(val);
      },
      immediate: true } },


  computed: {
    ...mapState({
      edit_doc_type: (state) => state.kbEditModule.edit_doc_type,
      doc_id: (state) => state.kbModule.doc_id,
      doc_info: (state) => state.kbEditModule.doc_info,
      doc_type: (state) => state.kbModule.doc_type,
      doc_view: (state) => state.kbModule.doc_view,
      treeNodes: (state) => state.kbTreeNodeModule.treeNodes,
      showSearch: (state) => state.kbSearchModule.showSearchPage,
      userId: (state) => state.userModule.userId,
      spaceId: (state) => state.userModule.spaceId }),

    ...mapGetters({
      faviconUrl: 'kbModule/faviconUrl' }),

    isInToca() {
      return getBrowser().isInTocaApp;
    } },

  methods: {
    onChangeEditStatus(isCanEdit: boolean) {
      this.$refs.mobileHeader?.onChangeEditStatus(isCanEdit);
    },
    openInnerAppLink() {
      const cloudLink = `toca://clouddisk/?fileId=${this.doc_id}`;
      window.open(cloudLink);
    },
    handleOpen() {
      if (getBrowser().isWeChat) {
        window.location.href = `https://guanjia.tcent.cn/clouddisk/${this.doc_id}`;
      } else {
        this.openInnerAppLink();
      }
    },
    startFieSocket() {
      if (this.fileSocket !== null) {
        this.fileSocket.wsClose();
        this.fileSocket = null;
      }
      const that = this;
      this.fileSocket = new FileSocket({
        params: {
          spaceId: this.spaceId,
          userId: this.userId,
          fid: this.doc_id },

        onMessage(arg: FileSocketResp) {
          that.onReceiveStatelessMsg(arg);
          that.handleSocketMessage(arg);
        },
        onSuccess() {} }).
      init();
    },
    handleSocketMessage(arg: FileSocketResp) {
      if (arg.eventType === 'FILE_RENAMED') {
        this.updateSelectDocName(arg.eventBody);
      } else if (arg.eventType === 'AUTH_CHANGED') {
        // if (this.doc_info?.fileInfo?.contentType)
        //     this.setDocType(this.doc_info.fileInfo.contentType);
        if (this.doc_info.fileInfo.contentType == 'DOCUMENT') {
          //ppt or excel本身弹了
          this.showAuthTipMsg(arg);
          // 移动端直接刷新
          // const { auth } = arg.eventBody;
          // if (!(auth === 'ALL' || auth === 'WRITE')) {
          //     window['tocaEditor']?.setIsCanEdit(false);
          //     let docInfo = this.doc_info;
          //     docInfo.auth = arg.eventBody.auth;
          //     docInfo.fileInfo.auth = arg.eventBody.auth;
          //     window['tocaEditor']?.updateDocInfo(docInfo);
          // }
        }
        //修改选中文件的auth
        // this.updateSelectDocAuth(arg.eventBody);

        //修改编辑器文档的auth
        setTimeout(() => {
          if (getBrowser().isInTocaApp === true) {
            window.open(window.location.href, '_self');
          } else {
            window.location.reload();
          }
        }, 1000);
      } else if (arg.eventType === 'FILE_DELETED') {
        let fileId = arg.eventBody.fileId;
        if (fileId && fileId.length > 0) {
          this.$refs.fileDirectory.handleDeleteFile(fileId, true);
        }
      } else if (arg.eventType === 'FILE_TRANSFERRED') {
        let fileId = arg.eventBody.fileId;
        // 转移文件权限
        this.$message.success(intl.$t("转移所有权成功"));
        // 更新文档创建人
        // window['tocaEditor']?.getDocInfoFromServer(fileId);
        // 434 - 转移所有权限后，重刷页面
        setTimeout(() => {
          if (getBrowser().isInTocaApp === true) {
            window.open(window.location.href, '_self');
          } else {
            window.location.reload();
          }
        }, 400);
      } else if (arg.eventType === 'WIKI_SPACE_SETTINGS_CHANGED') {
        // 兼容组织人才，编辑过程中，后端设置知识库只能只读逻辑
        const { readOnly } = arg.eventBody;
        const kbSetreadOnly =
        store.state.kbModule?.wikiSpaceInfo?.wikiSpaceSettings?.
        readOnly;
        if (readOnly !== kbSetreadOnly) {
          window.location.reload();
        }
      } else if (arg.eventType === 'FILE_RISK_CHANGED') {
        const { riskType } = arg.eventBody;
        // 判定是否是为包含敏感信息的高风险页面（非所有者查看提示缺省页，所有者查看提示顶部横幅（SensitiveContentTips））
        const creatorId = this.doc_info?.fileInfo?.creatorInfo?.userId;
        const userId = store.state.userModule.userId;
        const isAdmin = store.getters['kbTreeNodeModule/isAdmin'];
        if (riskType === 'HIGH' || riskType === 'MEDIUM' || riskType === 'LOW') {
          if (creatorId === userId || isAdmin === true) {
            if (this.$refs.editRef) {
              this.$refs.editRef.setSensitiveTipsStatus(2);
            }
            store.dispatch('sensitiveContentInfoModule/setShowSensitiveContentTips', true);
          } else {
            const employeeNo = this.doc_info?.fileInfo?.creatorInfo?.employeeNo || '';
            store.dispatch('sensitiveContentInfoModule/setCreator', this.doc_info?.fileInfo?.creator + (employeeNo ? `(${employeeNo})` : ''));
            store.dispatch('kbModule/setDocType', 'DOCUMENT');
            store.dispatch('kbEditModule/setEditDocType', 'SENSITIVEBLOCKED');
            return;
          }
        } else {
          store.dispatch('sensitiveContentInfoModule/setShowSensitiveContentTips', false);
          if (this.edit_doc_type === 'SENSITIVEBLOCKED') {
            this.checkFileAuth();
          }
        }
      }
    },
    showAuthTipMsg(arg) {
      let tipMsg = '';
      let auth = arg.eventBody.auth;
      switch (auth) {
        case 'READ':
          tipMsg = intl.$t("你在此文档的权限变更为仅查看");
          break;
        case 'READ_DOWNLOAD':
          tipMsg = intl.$t("你在此文档的权限变更为查看和下载");
          break;
        case 'WRITE':
          tipMsg = intl.$t("你在此文档的权限变更为编辑");
          break;
        case 'ALL':
          tipMsg = intl.$t("你在此文档的权限变更为所有权限");
          break;
        default:
          tipMsg = intl.$t("你在此文档的权限变更为无权限");
          break;}

      if (tipMsg && tipMsg.length > 0) {
        this.$message.info(tipMsg);
      }
    },
    ...mapActions({
      setTreeNodeData: 'kbTreeNodeModule/setTreeNodeData',
      setDocId: 'kbModule/setDocId',
      setDocType: 'kbModule/setDocType',
      setDocView: 'kbModule/setDocView',
      setDocInfo: 'kbEditModule/setDocInfo',
      setWikiSpaceInfo: 'kbModule/setWikiSpaceInfo',
      setEditDocType: 'kbEditModule/setEditDocType',
      onReceiveStatelessMsg: `${HocuspocusModule.moduleSpaceName}${HocuspocusModule.ON_RECEIVE_STATELESS_MSG}`,
      updateSelectDocName: `kbTreeNodeModule/updateSelectDocName`,
      updateSelectDocAuth: `kbTreeNodeModule/updateSelectDocAuth`,
      setShowSearchPage: 'kbSearchModule/setShowSearchPage' }),

    async initDir(doc_id) {
      if (!doc_id) {
        return;
      }
      try {
        const res: any = await getKBTreeNode(doc_id);
        const { code, data, message }: any = res.data || {};
        if (code == 200) {
          this.setTreeNodeData(data);
        } else {
          if (code !== 116 && code != 109 && code != 1109) {
            this.$message.error(message);
          }
          if (code === 1109) {
            // 显示新的信息，不显示后端返回的错误信息
            this.$message.error(intl.$t("权限不足，请联系管理员添加权限"));
          }
          //区分是否权限不足
          if (code == 601) {
            //展示知识库不存在页面
          } else if (code == 116) {
          } else if (code == 109) {
            let mockdata = {
              wikiSpaceInfo: {},
              treeNodes: [],
              memberIdentity: '',
              fileId: doc_id,
              memberAcl: '' };

            this.setTreeNodeData(mockdata);
          } else if (code == 1109) {
            // this.setDocView('home')
            // this.setDocType('DOCUMENT')
            data.source = '';
            data.wikiSpaceInfo.space = '';
            this.setTreeNodeData(data);
          } else {
            let mockdata = {
              wikiSpaceInfo: {},
              treeNodes: [],
              memberIdentity: '',
              fileId: doc_id,
              memberAcl: '' };

            this.setTreeNodeData(mockdata);
          }
        }
        console.log('目录节点接口数据获取成功: ', data);
      } catch (err) {
        //展示知识库不存在页面
      }
    },
    gotoSearch() {
      this.setShowSearchPage(true);
    } },

  unmounted() {
    this.fileSocket.wsClose();
  } };
</script>

<style lang="scss" scoped>
.main-view-mobile {
    flex-grow: 1;
    overflow: scroll;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.mobile-header {
    height: 42px;
    background-color: #fff;
    box-shadow: inset 0 -1px 0 0 #dee0e3;
}

.main_view {
    display: flex;
    width: 100%;
    height: 100vh;

    .loading_view,
    .no_kb_view {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .home_view,
    .setting_view,
    .trash_view {
        flex: 1;
        display: flex;
        min-width: 0;
    }
}
</style>

<style lang="scss">
.tiptap {
    width: 100%; // 手机版预览宽度占屏幕全宽
}
#edit_content_wrap .ProseMirror {
    box-sizing: border-box;
}

#app {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    text-align: unset;
}

html,
body {
    display: flex;
    flex-flow: column;
    height: 100%;
}
</style>
